import axios from '../../plugins/axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

// Опрос заявок для прогресса отправки. Идёт мимо plugins/api намеренно:
// там любая сетевая ошибка поднимает глобальную модалку с ошибкой, а здесь
// сбойный тик не событие — следующий через две секунды всё равно перезапросит.
const getCreditAppealSilent = (params) =>
  axios.get('/api/crm/creditPlatform/getCreditAppeal', {
    params,
    headers: { Authorization: `Bearer ${cookies.get('access_token')}` },
  });

export default getCreditAppealSilent;
